import { If, TabLink } from "components";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { Routes } from "modules/common";
import { InventoryInsights, NeverSold, PriceInsights } from "modules/insights";
import { useParams } from "react-router-dom";

import styles from "./InsightsPage.module.scss";

const InsightsPage = () => {
  const { activeTab } = useParams();
  const inventoryRoutes = Routes.find((route) => {
    return route.label === "Insights";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Insights")}>
      <BoxShadowLayout className={styles.pageContent}>
        <If condition={!!inventoryRoutes}>
          <nav>
            {inventoryRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={t(route.label)}
              />
            ))}
          </nav>
        </If>

        <If condition={activeTab === "never-sold"}>
          <NeverSold />
        </If>
        <If condition={activeTab === "inventory-insights"}>
          <InventoryInsights />
        </If>

        <If condition={activeTab === "price-insights"}>
          <PriceInsights />
        </If>
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default InsightsPage;
